export default __webpack_public_path__ + "static/hero_image-cropped-7213dc9d0fb71acc3bf64864881a22f7.png";